import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppUrls } from '../../utility/appurls';
import { IdentityService } from '../identity.service';
import { UrlUtility } from '../../utility/url-utility';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
})
export class AuthCallbackComponent implements OnInit {
  private router = inject(Router);
  private identityService = inject(IdentityService);

  
 

  

  ngOnInit() {
    const authCode = UrlUtility.GetQueryStringValue('code');

    if (authCode) {
      this.identityService.loginWithAuthCode(authCode).subscribe(() => {
        if (this.identityService.isValidLogin === false) {
          this.router.navigate([AppUrls.invalidDomain()], { replaceUrl: true });
        } else if (
          !this.identityService.redirectPath ||
          this.identityService.redirectPath === 'null' ||
          this.identityService.redirectPath.includes(AppUrls.logout())
        ) {
          this.router.navigate([AppUrls.home()], { replaceUrl: true });
        } else {
          const redirectPath = this.identityService.redirectPath;
          this.identityService.redirectPath = null;
          this.router.navigateByUrl(redirectPath, { replaceUrl: true });
        }
      });
    }
  }
}
